import { DAY_PASCAL } from '../../constants';
import { REDUX_KEY } from '../../redux/constants';
import { updateField } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { SelectField } from '../SelectField';
import BasicGapContainer from './BasicGapContainer';

const CommencingDaySelector = () => {
  const dispatch = useAppDispatch();
  const commencingDay = useAppSelector(
    (state: RootState) => state.detail.commencingDay
  );

  const handleChange = (value: string): void => {
    dispatch(
      updateField({
        fieldName: REDUX_KEY.COMMENCING_DAY,
        value
      })
    );
  };

  return (
    <BasicGapContainer>
      <h3>W/C Day</h3>
      <SelectField
        id="commencing-day"
        label="W/C Day"
        options={Object.values(DAY_PASCAL)}
        onChange={handleChange}
        value={commencingDay}
      />
    </BasicGapContainer>
  );
};

export default CommencingDaySelector;
